import * as React from "react";
import Box from "@mui/material/Box";
import { useFollowTutorMutation } from "../service/content";
import { showError } from "../constants/toast";
import { useNavigate } from "react-router-dom";

const TutorListing = ({ recommended, tutor }: any) => {
    const [followTutor] = useFollowTutorMutation();
    const navigate=useNavigate();

    const followTutorFunc = async (item: any) => {
        const body = {
            tutorId: item?._id || "",
        };
        try {
            const res = await followTutor(body).unwrap();
            if (res?.statusCode == 200) {

            }
        } catch (error: any) {
            showError(error?.data?.message || "Something went wrong");
        }
    };

    return (
        <Box >
            {tutor ? null : (
                <section className=" side_menu_wrap tutor_wrp">
                    <div className="title_hd">
                        <h2>Tutor Listing</h2>
                    </div>
                    <ul className="tutor_list">
                        {recommended?.map((item: any) => {
                            return (
                                <li>
                                    <div className="inr_dtl">
                                        <figure>
                                            <img src={item?.image || `/static/images/emaa.png`} alt="emaa" />
                                        </figure>
                                        <div className="dtls">
                                            <h2>{item?.name || ""}</h2>
                                            <p>{''} <span>{item?.followers || "0"} Followers</span></p>
                                            <small>Exp: {item?.teachingdetails?.totalTeachingExperience ? item?.teachingdetails?.totalTeachingExperience + " years" : ""}</small>
                                        </div>
                                    </div>
                                    <button onClick={() => followTutorFunc(item)} className="btn transparent">{item?.isFollowing ? "Following" : "Follow"}</button>
                                </li>
                            )
                        })}


                    </ul>
                </section>
            )}


            <section className="side_menu_wrap unlock_bg ">
                <div className="group">
                    <h4>Unlock Learning, Book Your Perfect Tutor Today!</h4>
                    <button>Book Now</button>
                </div>
                <figure>
                    <img src={`/static/images/unlock_men.png`} alt="unlock_men" />
                </figure>
            </section>
            {/* <section className="side_menu_wrap  page_link">
                <ul>
                    <li onClick={()=>navigate('/about-us')}>
                        <a>About Us</a>
                    </li>
                    <li onClick={()=>navigate('/contact-us')}>
                        <a>Contact Us</a>
                    </li>
                    <li onClick={()=>navigate('/about-us')}>
                        <a>Help Center</a>
                    </li>
                    <li onClick={()=>navigate('/parent/terms-and-conditions')}>
                        <a>Terms & conditions</a>
                    </li>
                    <li onClick={()=>navigate('/privacy-policy')}>
                        <a>Privacy Policy</a>
                    </li>
                    <li onClick={()=>navigate('/about-us')}>
                        <a>FAQ’s</a>
                    </li>
                </ul>
            </section> */}
        </Box>
    );
};

export default TutorListing;
